// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RelatedEntity
 */
export interface RelatedEntity {
  /**
   *
   */
  id: string;
  /**
   *
   */
  type: RelatedEntityTypeEnum;
  /**
   *
   */
  role?: string | null;
}

/**
 * @export
 */
export const RelatedEntityTypeEnum = {
  Publication: "publication",
  Project: "project",
  Tenant: "tenant",
} as const;
export type RelatedEntityTypeEnum =
  (typeof RelatedEntityTypeEnum)[keyof typeof RelatedEntityTypeEnum];

/**
 * Check if a given object implements the RelatedEntity interface.
 */
export function instanceOfRelatedEntity(value: object): value is RelatedEntity {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  return true;
}

export function RelatedEntityFromJSON(json: any): RelatedEntity {
  return RelatedEntityFromJSONTyped(json, false);
}

export function RelatedEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelatedEntity {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    type: json["type"],
    role: json["role"] === undefined ? undefined : json["role"] === null ? null : json["role"],
  };
}

export function RelatedEntityToJSON(json: any): RelatedEntity {
  return RelatedEntityToJSONTyped(json, false);
}

export function RelatedEntityToJSONTyped(
  value?: RelatedEntity | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    type: value["type"],
    role: value["role"],
  };
}
